module.exports = __webpack_public_path__ + "img/icon-32-ic-androidbox-inactive.17d7a52f.svg";